<template lang="html">
  <section>
      <v-parallax :src="require('@/assets/people-students.jpg')" :height="200" class="parallax-bg-image">
          <v-layout
              column
              align-center
              justify-center
          >
              <v-img :src="require('@/assets/Alumnier_logo.png')" :alt="Alumnier" max-height="200" contain>
              </v-img>
          </v-layout>
      </v-parallax>
  </section>
</template>

<script>
export default {
  name: 'ParallaxAlumnier'
}
</script>

<style>
  .parallax-bg-image > .v-parallax__image-container {
        opacity: 0.44;
        -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
        filter: grayscale(100%);
  }
</style>
